import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";
import {useCounterUp} from "../../../../../infrastructure/hooks/useCounterUp";
import {PROPOSITION_BETS} from "../../../proposition-bets-widgets.consts";

export const PropositionBetsWidgetRowProgressBarValue = observer(({controller, row}) => {
  const {state} = controller;
  const {isScheduled, isLive} = state;
  const {parameter, currentValue, currentValueRatio} = row;
  const countDuration: Number = PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.duration  * currentValueRatio;
  const count: Number = !isScheduled ? useCounterUp(currentValue, countDuration, PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.delay) : parameter;

  return count > -1 ? <div className={classNames(styles.parameter_value, {[styles.parameter_value_scheduled]: isScheduled, [styles.parameter_value_live]: isLive})}>{count}</div> : null;
});
